import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxStockGroup' })
export class StockGroupPipe implements PipeTransform {
  transform(input: any[], stockGroupId: number): any[] {
    return input.filter((st) => st.stockGroupId === stockGroupId);
  }
}
